import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars';
import type { TabMain } from '@types';
import { TipWrapper } from '@components/TipWrapper';
import ImgBasic from './img-basic.png';
import ImgView from './img-view.png';
import ImgHotspot from './img-hotspot.png';
import ImgAudio from './img-audio.png';
import ImgMask from './img-mask.png';
import ImgSandTable from './img-st.png';
import ImgEffect from './img-effect.png';
import ImgRotate from './img-rorate.png';
import ImgSubtitle from './img-subtitle.png';
import ImgTagLine from './img-tagline.png';
import ImgCompass from './img-compass.png';
import ImgComponent from './img-component.png';
import ImgCompare from './img-compare.png';

function Toolbar() {
  return (
    <div className="flex w-40 flex-shrink-0 flex-col">
      <Scrollbars>
        <Item src={ImgBasic} title="全局" text="全局设置" tab="basic" />
        <Item src={ImgView} title="视角" text="视角设置" tab="view" />
        <Item src={ImgHotspot} title="热点" text="热点/嵌入" tab="hotspot" />
        <Item src={ImgComponent} title="图层" text="图层设置" tab="component" />
        <Item src={ImgAudio} title="音乐" text="背景音乐" tab="music" />
        <Item src={ImgRotate} title="导览" text="导览讲解" tab="rotate" />
        <Item src={ImgEffect} title="特效" text="特效设置" tab="effect" />
        <Item src={ImgMask} title="遮罩" text="遮罩设置" tab="mask" />
        <Item src={ImgSandTable} title="沙盘" text="场景沙盘" tab="sandTable" />
        <Item src={ImgSubtitle} title="字幕" text="公告字幕" tab="subtitle" />
        <Item src={ImgTagLine} title="标尺" text="标尺标注" tab="tagLine" />
        <Item src={ImgCompare} title="对比" text="场景对比" tab="compare" />
        <Item src={ImgCompass} title="指北针" text="指北针" tab="compass" />
      </Scrollbars>
    </div>
  );
}

interface ItemProps {
  src: string;
  title: string;
  text: string;
  tab: TabMain;
}

const Img = styled.img`
  width: 32px;
  height: 32px;
`;

function Item({ src, tab, title, text }: ItemProps) {
  return (
    <TipWrapper className="mb-5" text={text} placement="right">
      <NavLink
        to={tab}
        className={({ isActive }) =>
          `relative flex w-40 flex-col items-center justify-center rounded py-5 ${
            isActive
              ? 'bg-blue text-white'
              : ' text-black-gray hover:bg-black-border'
          }`
        }
      >
        <Img src={src} alt="" />
        <div className="text-sm">{title}</div>
      </NavLink>
    </TipWrapper>
  );
}

export default Toolbar;
